// リダイレクトURL
export const REDIRECT_URL = 'COLORFULLY_MANAGEMENT_REDIRECT_URL';
